var _circle, _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryUrkposhta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 15,
    cy: 15.0002,
    r: 12.6316,
    fill: "#169CE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.161 10.3369V16.5264H13.0115V13.8737H9.81067V16.5264H8.66119V10.3369H9.81067V12.8923H13.0115V10.3369H14.161ZM21.3793 10.3369V16.5264H20.2475V11.3095H17.0378V16.5264H15.9061V10.3369H21.3793Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.36865,
    y: 2.36816,
    width: 25.2632,
    height: 25.2632,
    rx: 3.78947,
    fill: "#FABC26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4868 16.5205C21.4863 16.5204 14.6382 14.9826 14.6382 14.9826C12.597 14.5242 11.3166 12.5105 11.7784 10.4848C12.2404 8.45914 14.2697 7.18876 16.3108 7.64701C18.3521 8.10542 19.6324 10.1191 19.1706 12.1446C18.9392 13.1588 18.3149 13.9829 17.493 14.4963C17.4929 14.4963 17.4909 14.498 17.4901 14.4984C17.4659 14.5156 17.4503 14.5436 17.4503 14.5751C17.4503 14.6193 17.481 14.6565 17.5226 14.6664C17.5227 14.6665 20.569 15.3501 20.5695 15.3501C20.642 15.3664 20.7173 15.3387 20.7618 15.2803C20.7621 15.2797 20.762 15.2801 20.762 15.2801C21.6012 14.1781 22.1053 12.8031 22.1053 11.3158C22.1053 7.81334 19.3478 4.95101 15.8696 4.74771C15.8386 4.74601 15.6502 4.7387 15.5865 4.7378C14.0465 4.71381 12.4851 5.152 11.1273 6.09562C7.69842 8.47815 6.86532 13.1678 9.26597 16.5703L15.3587 25.2052C15.3847 25.2404 15.4266 25.2632 15.4736 25.2632C15.521 25.2632 15.5631 25.24 15.589 25.2045C15.589 25.2045 21.5719 16.7375 21.5724 16.7368C21.5877 16.7143 21.5968 16.6871 21.5968 16.6579C21.5968 16.5909 21.5498 16.5349 21.4868 16.5205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryUrkposhta);
export default __webpack_public_path__ + "static/media/delivery_urkposhta.7d4fbac785cf209510125d12f85edbcd.svg";
export { ForwardRef as ReactComponent };